export enum EnumEnterpriseServerRequest {
    RESELLER_INFO,
    ACCOUNT_DETAILS,
    BUSINESSES_INFO,
    BUSINESS_USERS,
    STATION_DOMAIN_COLLECTION,
    STATION_COLLECTION_GEOIP,
    STATION_DOMAIN_COLLECTION_SOCKET_NAMES
}

export interface IEnterpriseWhiteLabelUpdate {
    whitelabelEnabled: string;
    defaultThemeId: '0' | '1';
    theme: '0' | '1';
    companyName: string;
    logoTooltip: string;
    logoLink: string;
    createAccountOption: string;
    linksHome: string;
    linksDownload: string;
    linksContact: string;
    twitterShow: string;
    twitterLink: string;
    bannerEmbedReference: string;
    chatShow: string;
    chatLink: string;
    mainMenuLink0: string;
    mainMenuLabel0: string;
    mainMenuLink1: string;
    mainMenuLabel1: string;
    mainMenuLink2: string;
    mainMenuLabel2: string;
    mainMenuLink3: string;
    mainMenuLabel3: string;
    mainMenuLink4: string;
    mainMenuLabel4: string;
}

export type PrivilegeModules =
    'Campaigns' |                              // Campaigns$ section: User Management
    'Campaign | User Management' |             // Campaigns$ section: User Management
    'Screens' |                                // Screens$ section: Enterprise
    'Screens | Enterprise section' |           // Screens$ section: Enterprise
    'Global' |                                 // Global$ tab: Profile > Settings if true and Changelist true, no Profile
    'Global | Profile > Settings' |            // Global$ tab: Profile > Settings if true and Changelist true, no Profile
    'Changelist' |                             // Changelist$ tab: Profile > Personal if true and Global true, no Profile
    'Changelist | Profile > Personal' |        // Changelist$ tab: Profile > Personal if true and Global true, no Profile
    'Editors' |                                // Editors$ | Scenes
    'Resources' |                              // Resources$
    'Catalog' |                                // Catalog$
    'EventParams' |                            // EventParams$
    'Transitions' |                            // Transitions$
    'AdNet' |                                  // Adnet$ not implemented since I only support it in Dashboard so always full access
    'Music' |                                  // Music$
    'Stations' |                               // Stations$
    'SignStudio ExperienceLevel' |
    'SignStudio Dashboard' |
    'SignStudio Editor' |
    'SignStudio Resources' |
    'SignStudio Products' |
    'SignStudio Help' |
    'SignStudio Downloads' |
    'SignStudio Players' |
    'SignStudio Painter' |
    'SignStudio Scheduler' |
    'SignStudio FasterQ' |
    'SignStudio Adnet' |
    'SignStudio Music' |
    'SignStudio Settings' |
    'SignStudio Account' |
    'SignStudio Catalog' |
    'SignStudio Events' |
    'SignStudio Transitions' |
    'SignStudio Scripting';


export type PrivilegeModulesTable = 'global_settings' | 'settings' | 'visible' | 'boards' | 'board_templates' | 'board_template_viewers' | 'resources' | 'player_data' |
    'catalog_items' | 'catalog_item_infos' | 'catalog_item_resources' | 'catalog_item_categories' | 'category_values' | 'players' | 'fasterQ' | 'branch_stations' | 'station_ads' |
    'campaign_events' | 'event_params' | 'transition_pools' | 'transition_pool_items' | 'music_channels' | 'music_channel_songs' | 'adnet_rates' |
    'adnet_targets' | 'adnet_packages' | 'adnet_package_contents' | 'adnet_package_targets';

export type  PrivilegeModulesProperties = 'name' | 'visible' | 'stationsNetwork' | 'updateOnSave' | 'lanServer' | 'cameraCheck' | 'resourceMode'
    | 'data' | 'profile' | 'customerNetwork' | 'resellerNetwork' | 'globalNetwork' | 'defaultAutoActivate' | 'pairFeedback' | 'pairSetting' | 'pairChat' | 'billing' | 'assets';

export interface IEnterpriseReseller {
    User: User;
}

interface User {
    $: GeneratedType;
    BusinessInfo: BusinessInfo[];
}

interface GeneratedType {
    name: string;
    privilegeId: string;
    accessMask: string;
}

interface BusinessInfo {
    $: GeneratedTypeBusinessInfo2;
    WhiteLabel: IWhiteLabel[];
    Privileges: IPrivilege[];
    Themes: Theme[];
    InstalledApps: IInstalledApp[];
    AdNet: AdNet[];
    ResellerInfo: ResellerInfo[];
    SourceInfo: SourceInfo[];
    Sources: Source[];
    Apps: IStoreApps[];
    Weathers: Weather[];
}

interface GeneratedTypeBusinessInfo2 {
    businessId: string;
    name: string;
    businessDescription: string;
    accountStatus: string;
    archiveState: string;
    applicationId: string;
    resellerId: string;
    payerId: string;
    fromTemplateId: string;
    maxMonitors: string;
    maxDataStorage: string;
    studioLite: string;
    allowSharing: string;
    lastLogin: string;
}

interface Weather {
    Weather: Weather2[];
}

interface Weather2 {
    $: GeneratedType3;
}

interface GeneratedType3 {
    name: string;
    weatherSwf: string;
    weatherClass: string;
    id: string;
}

interface AdNet {
    $: GeneratedType4;
}

interface GeneratedType4 {
    accountId: string;
    customerId: string;
    customerToken: string;
}

interface ResellerInfo {
    BusinessInfo: BusinessInfo2[];
}

interface BusinessInfo2 {
    $: GeneratedType5;
    WhiteLabel: IWhiteLabel[];
    Theme: Theme[];
    InstalledApps: IInstalledApp[];
    Privilege: Privilege[];
}

interface GeneratedType5 {
    businessId: string;
    name: string;
    businessDescription: string;
    accountStatus: string;
    archiveState: string;
    applicationId: string;
    resellerId: string;
    payerId: string;
    providerId: string;
}

export interface IWhiteLabelSingle {
    Studio: IStudio;
}

export interface IWhiteLabel {
    $: GeneratedType6;
    Studio: IStudio[];
    companyName?: string;
    defaultThemeId?: '0' | '1';
}

interface GeneratedType6 {
    enabled: string;
}

export interface IStudio {
    Application: Application[];
    MainMenu: MainMenu[];
    Banner: Banner[];
    Twitter: Twitter[];
    Chat: Chat[];
}

interface Application {
    Logo: Logo[];
    Links: Link[];
    CreateAccount: CreateAccount[];
}

interface Logo {
    $: LogoDetails;
}

interface LogoDetails {
    tooltip: string;
    link: string;
    filename: string;
}

interface Link {
    $: GeneratedType8;
}

interface GeneratedType8 {
    home: string;
    download: string;
    contact: string;
}

interface CreateAccount {
    $: GeneratedType9;
}

interface GeneratedType9 {
    show: string;
}

interface MainMenu {
    CommandGroup: CommandGroup[];
}

interface CommandGroup {
    $: GeneratedType10;
    Command: Command[];
}

interface GeneratedType10 {
    id: string;
    label: string;
    icon: string;
}

interface Command {
    $: GeneratedType11;
}

interface GeneratedType11 {
    id: string;
    label: string;
    href: string;
}

interface Banner {
    $: GeneratedType12;
}

interface GeneratedType12 {
    embeddedReference: string;
}

interface Twitter {
    $: GeneratedType13;
}

interface GeneratedType13 {
    show: string;
    link: string;
}

interface Chat {
    $: GeneratedType14;
}

interface GeneratedType14 {
    show: string;
    link: string;
}

interface Theme {
    $: GeneratedType15;
}

interface GeneratedType15 {
    name: string;
    defaultThemeId: string;
    ver: string;
    studioStyles: string;
    playerStyles: string;
    studioIcons: string;
    playerIcons: string;
    componentIcons: string;
}

export interface IInstalledApp {
    App: App[];
}

interface App {
    $: GeneratedType16;
}

interface GeneratedType16 {
    id: string;
    installed: string;
}

export interface IPrivilege {
    $: GeneratedType122;
    Privilege: IPrivileges[];
}

interface GeneratedType122 {
    defaultPrivilegeId: string;
}

interface Privilege {
    $: GeneratedType17;
    Groups: IGroup[];
}

interface GeneratedType17 {
    id: string;
    name: string;
}

export interface IPrivileges {
    $: IPrivDetails;
    Groups: Array<IGroup> | IGroupsPrivileges;
}

export interface IGroupsPrivileges {
    Group: Array<IGroupCollection>;
}

export interface IGroup {
    Group: IGroupCollection[];
}

interface IPrivDetails {
    id: string;
    name: string;
}

export interface IGroupCollection {
    $: IGroupCollectionDetails;
    Tables: Array<IGroupCollectionTables> | null;
}

interface GenericKeyString {
    $: {
        [key: string]: string;
    };
}

export interface IGroupCollectionTables {
    $: {
        [key: string]: string;
    };
}

// player_data?: '0' | '1' | '3' | '7'; // 0 = NOTHING |}  1 == UPDATE || 3 = ADD / UPDATE || 7 = DELETE / ADD / UPDATE

export interface IGroupCollectionDetails {
    name: PrivilegeModules;
    longName?: string;
    visible?: '0' | '1';
    header?: '0' | '1';
    upload?: '0' | '1';
    import?: '0' | '1';
    showCustomHome?: '0' | '1';
    resellerCollectUserEmail?: '0' | '1';
    navEnterprise?: '0' | '1';
    navProducts?: '0' | '1';
    navUser?: '0' | '1';
    navChat?: '0' | '1';
    navSearch?: '0' | '1';
    navTargets?: '0' | '1';
    navGlobal?: '0' | '1';
    navModule?: '0' | '1';
    navScene?: '0' | '1';
    navMain?: '0' | '1';
    preview?: string;
    resourceMode?: string;
    data?: string;
    profile?: string;
    customerNetwork?: string;
    resellerNetwork?: string;
    globalNetwork?: string;
    defaultAutoActivate?: string;
    pairFeedback?: string;
    pairSetting?: string;
    pairChat?: string;
    billing?: string;
    assets?: string;
    stationsNetwork?: string;
    updateOnSave?: string;
    lanServer?: string;
    cameraCheck?: string;
}

interface SourceInfo {
    $: GeneratedType19;
}

interface GeneratedType19 {
    id: string;
    serverName: string;
    businessDomain: string;
    businessDbName: string;
    socketDomain: string;
}

interface Source {
    SourceInfo: SourceInfo2[];
}

interface SourceInfo2 {
    $: GeneratedType20;
}

interface GeneratedType20 {
    id: string;
    serverName: string;
    businessDomain: string;
    businessDbName: string;
    socketDomain: string;
}

export interface IStoreApps {
    App: IAppCollection[];
}

export interface IAppCollection {
    $: GeneratedType21;
    Description: string[];
    Components: Component[];
}

interface GeneratedType21 {
    id: string;
    appName: string;
    helpName: string;
    uninstallable: string;
    hidden: string;
    price: string;
}

interface Component {
    Component: Component2[];
}

interface Component2 {
    $: IEnterpriseAppModel;
    MimeTypes?: MimeType[];
}

export interface IEnterpriseAppModel {
    moduleId: string;
    componentName: string;
    version: string;
    moduleWeb: string;
    moduleAir: string;
    moduleMobile: string;
    showInTimeline: string;
    showInScene: string;
    easy: string;
    componentParams?: string;
}

interface MimeType {
    MimeType: MimeType2[];
}

interface MimeType2 {
    $: GeneratedType23;
}

interface GeneratedType23 {
    name: string;
    providerType?: string;
    label: string;
}


// export interface IReseller {
//   createAccountOption: string;
//   chatShow: string;
//   twitterShow: string;
//   resellerSourceId: string;
//   whitelabelEnabled: string;
//   accountStatus: string;
//   applicationId: string;
//   archiveState: string;
//   businessDescription: string;
//   businessId: string;
//   companyName: string;
//   providerId: string;
//   resellerId: string;
//   payerId: string;
//   linksContact: string;
//   linksDownload: string;
//   linksHome: string;
//   logoLink: string;
//   logoTooltip: string;
//   fileName: string;
//   bannerEmbedReference: string;
//   chatLink: string;
//   mainMenuLink0: string;
//   mainMenuId0: string;
//   mainMenuLabel0: string;
//   mainMenuLink1: string;
//   mainMenuId1: string;
//   mainMenuLabel1: string;
//   mainMenuLink2: string;
//   mainMenuId2: string;
//   mainMenuLabel2: string;
//   mainMenuLink3: string;
//   mainMenuId3: string;
//   mainMenuLabel3: string;
//   mainMenuId4: string;
//   mainMenuLink4: string;
//   mainMenuLabel4: string;
//   icon: string;
//   iconId: string;
//   iconLabel: string;
//   twitterLink: string;
// }
